import {
  Box,
  Grid2,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormStyles } from "../../../hooks";
import { MeasurementPreview } from "../../../types/interfaces/file/imports/flowTestMeasurements";
import { formatTimestamp } from "../../../utils";

interface UploadMeasurementFormProps {
  measurement: MeasurementPreview;
  variableName: string;
  variableUnit: string;
}

export const UploadMeasurementForm = ({
  measurement,
  variableName,
  variableUnit,
}: UploadMeasurementFormProps) => {
  const { t } = useTranslation();
  const formStyles = useFormStyles(true);

  return (
    <Box>
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("flow-tests.flow-test-measurement.title")}
            </Typography>
            <Grid2 container spacing={2}>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.measured-capture")}
                  value={measurement.measuredCaptureIdentifier}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.measured-at")}
                  value={measurement.measuredAt ? formatTimestamp(measurement.measuredAt) : ""}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.testing-time")}
                  value={measurement.testingTime ?? ""}
                  disabled
                  sx={{ ...formStyles }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          {t("generic.units.minutes")}
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.variable")}
                  value={variableName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.value")}
                  value={measurement.value}
                  disabled
                  sx={{ ...formStyles }}
                  slotProps={{
                    input: {
                      startAdornment: measurement.flag
                        ? <InputAdornment position="start">{measurement.flag}</InputAdornment>
                       : undefined,
                      endAdornment: <InputAdornment position="end">{variableUnit}</InputAdornment>
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={12}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.notes")}
                  value={measurement.notes ?? ""}
                  disabled
                  multiline
                  minRows={3}
                  sx={{ ...formStyles }}
                />
              </Grid2>

            </Grid2>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};